// @flow

import React from 'react';
import type { Node } from 'react';
import { Section, SectionContent, Wrapper } from '@riseart/layout';

type Props = {
  background?: string,
  className?: string,
  title: string | Node,
  sectionContentProps?: Object,
  children: Node,
};

/**
 * ArtSliderSection
 *
 * @param {Props} props
 * @returns {Node}
 */
export const ArtSliderSection = ({
  title,
  children,
  sectionContentProps,
  ...restProps
}: Props): Node => (
  <Section {...restProps}>
    <Wrapper
      sizes={{
        xs: 'wide',
        sm: 'wide',
        md: 'wide',
        lg: 'narrow',
        xl: 'narrow',
      }}
    >
      <SectionContent title={title} {...(sectionContentProps || null)}>
        {children}
      </SectionContent>
    </Wrapper>
  </Section>
);
